import { getFormInfo } from '../../forms/types';
import Logger from '../../logging/logger';
import { initGlobalAnalyticClickEvents } from './click-events';
import triggerEvent, { FormSubmitEvent, GAEventName } from './events';
import { initGlobalAnalyticEventHandler } from './global-event-handler';

export function initGoogleAnalyticHandlers(): void {
    if ( window.baseAnalyticEventParameters ) {
        Logger.info( 'Initialising analytis with base parameters', window.baseAnalyticEventParameters );
    }

    Logger.info( 'Initialising analytic click events' );

    initGlobalAnalyticClickEvents();

    Logger.info( 'Initialising single-click event handling' );

    initGlobalAnalyticEventHandler();

    window.addEventListener( 'appinstalled', () => {
        triggerEvent<FormSubmitEvent>( GAEventName.FormSubmit, {
            'form_name': 'pwa_installed',
        } );
    } );

    window.addEventListener( 'beforeinstallprompt', ( event: BeforeInstallPromptEvent ) => {
        event.preventDefault();

        triggerEvent<FormSubmitEvent>( GAEventName.FormSubmit, {
            'form_name': 'pwa_install_prompt',
        } );
    } );

    window.addEventListener( 'submit', ( event: SubmitEvent ) => {
        if ( 'agentInvoked' in event && event.target instanceof HTMLFormElement ) {
            triggerEvent<FormSubmitEvent>( GAEventName.FormSubmit, {
                'form_name': `agentic_submit_${getFormInfo( event.target ).name}`,
            } );
        }
    } );
}
